import { createFileRoute } from '@tanstack/react-router'
import NewConceptLiveCalculation from 'Concept/components/Concept/Sections/NewLiveCalculation/NewConceptLiveCalculation'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/concept/$conceptId/pre-calculation')({
    component: () => (
        <Guard notFeatures={['profitability']}>
            <NewConceptLiveCalculation />
        </Guard>
    ),
})
